import React from 'react';

function Byggstadning() {
  return (
    <>
        <section
            className="relative h-[40vh] bg-cover bg-center flex items-center justify-center text-white"
            style={{
            backgroundImage: "url('/images/cleaning/byggstadning-provalt.jpg')", // byt till korrekt bildsökväg
            }}
        >
            {/* Skuggöverlägg */}
            <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />

            {/* Textinnehåll */}
            <div className="relative z-10 text-center p-6 bg-black bg-opacity-30 rounded-md">
            <h1 className="text-4xl md:text-5xl font-bold mb-3">Byggstädning</h1>
            <p className="text-xl md:text-2xl font-semibold">
                Professionell byggstädning – Rent & klart för inflyttning!
            </p>
            </div>
        </section>
        <section className="py-16 px-6 md:px-12 bg-white text-gray-800">
            <div className="max-w-6xl mx-auto">
                {/* Inledningstext */}
                <h2 className="text-3xl font-bold mb-6">Är du i behov av byggstäd?</h2>
                <p className="mb-6 text-lg">
                Vi erbjuder professionell byggstädning för byggföretag, fastighetsägare och privatpersoner. Oavsett om du behöver grovstädning
                under ett pågående bygge eller en noggrann slutstädning innan inflytt, ser vi till att byggdamm, skräp och smuts försvinner.
                </p>
                <p className="mb-10 text-lg">
                Med vårt erfarna team, effektiva metoder och miljövänliga rengöringsprodukter lämnar vi din fastighet skinande ren och redo
                för användning. Vi arbetar snabbt, noggrant och anpassar oss efter dina behov – allt till konkurrenskraftiga priser.
                Kontakta oss idag för en kostnadsfri offert!
                </p>

                {/* Lista: Vad ingår */}
                <h3 className="text-2xl font-semibold mb-6">Vad ingår i en byggstädning?</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                {/* Vänstersida */}
                <div>
                    <h4 className="text-xl font-semibold mb-3">Gäller för samtliga rum</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Allt byggdamm tas hand om. Byggsopor tas om hand mot extra kostnad.</li>
                    <li>Dammsugning av byggdamm och våttorkning av golvet.</li>
                    <li>Rengöring av alla ytor.</li>
                    <li>Rengöring av alla dörrar, dörrkarmar, väggar, vägglister och väggkontakter.</li>
                    <li>Rengöring av alla element.</li>
                    <li>Rengöring av garderober.</li>
                    </ul>

                    <h4 className="text-xl font-semibold mt-6 mb-3">Badrum/Dusch och toalett</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Dammsugning och våttorkning av golvet.</li>
                    <li>Rengöring av väggar.</li>
                    <li>Rengöring av sanitär inredning.</li>
                    <li>Rengöring av samtliga ytor.</li>
                    </ul>
                </div>

                {/* Högersida */}
                <div>
                    <h4 className="text-xl font-semibold mb-3">Kök</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Rengöring av köksbänkar och arbetsytor.</li>
                    <li>Avtorkning av skåp, handtag och vitvaror utvändigt.</li>
                    <li>Rengöring av diskho och blandare.</li>
                    </ul>

                    <h4 className="text-xl font-semibold mt-6 mb-3">Fönsterputs</h4>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Fönsterputsning invändigt och utvändigt där det är möjligt.</li>
                    <li>Borttagning av byggdamm och fläckar från glasytor.</li>
                    </ul>
                </div>
                </div>
            </div>
        </section>
        <section className="py-16 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-start">
                {/* Textinnehåll */}
                <div>
                <h2 className="text-3xl font-bold mb-4">Offertförfrågan</h2>
                <p className="mb-4">
                    Vill du få en kostnadsfri offert eller veta mer om våra tjänster? Fyll i formuläret så kontaktar vi dig så snart som möjligt.
                </p>

                <h3 className="text-xl font-semibold mb-3">Varför välja oss?</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li><strong>Erfarenhet & Kvalitet</strong> – Vi har erfaren personal som vet hur byggstädning ska göras.</li>
                    <li><strong>Snabb & flexibel service</strong> – Vi anpassar oss efter ditt byggprojekt och dina tidskrav.</li>
                    <li><strong>Miljövänliga rengöringsmedel</strong> – Skonsamt för både miljö och inomhusklimat.</li>
                    <li><strong>Försäkrade & pålitliga</strong> – Trygghet med försäkrad personal och kvalitetsgaranti.</li>
                    <li><strong>Konkurrenskraftiga priser</strong> – Prisvärda lösningar utan att tumma på kvaliteten.</li>
                </ul>

                <p className="mt-6 font-semibold text-gray-800">Svar inom 24 timmar.</p>
                </div>

                {/* Formulär */}
                <form className="bg-white shadow-md rounded-lg p-6 space-y-4">
                <div>
                    <label className="block text-sm font-medium mb-1">Namn</label>
                    <input type="text" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">E-post</label>
                    <input type="email" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Telefonnummer</label>
                    <input type="tel" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Ämne</label>
                    <input type="text" className="w-full border rounded p-2" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Meddelande</label>
                    <textarea className="w-full border rounded p-2 h-28 resize-none" />
                </div>
                <button
                    type="submit"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded w-full font-semibold"
                >
                    Skicka
                </button>
                </form>
            </div>
        </section>



    </>
  );
}

export default Byggstadning;
